<template>
  <div class="hzc-price-index">
    <div class="back">当前位置：<span @click="back('/steel')">钢铁</span> > <span
        @click="back('/steel/twoPage/enterprise')">重点企业资讯</span> > 正文
    </div>
    <DetailTitle :title="endTime + '钢铁重点企业资讯'"></DetailTitle>
    <div class="hzc-echarts">
      <div class="echarts">
        <div class="title"><span></span>
          <p>焦炭库存(万吨)</p></div>
        <div id="myChart" style="width: 600px;height:340px;"></div>
      </div>
      <div class="echarts">
        <div class="title"><span></span>
          <p>使用天数(天)</p></div>
        <div id="myChart1" style="width: 600px;height:340px;"></div>
      </div>
      <div class="echarts">
        <div class="title"><span></span>
          <p>产品库存(万吨)</p></div>
        <div id="myChart2" style="width: 600px;height:340px;"></div>
      </div>
      <div class="echarts">
        <div class="title"><span></span>
          <p>开工率(%)</p></div>
        <div id="myChart3" style="width: 600px;height:340px;"></div>
      </div>
    </div>
    <el-table
        :data="tableData"
        :header-cell-style="{background:'#f2f2f2',color:'#222'}"
        height="700"
        border
        style="width: 100%;margin-top: 20px;margin-bottom: 30px;">
      <el-table-column
          type="index"
          fixed
          label="序号"
          width="50">
      </el-table-column>
      <el-table-column
          align="left"
          fixed
          prop="client"
          width="200px"
          label="客户">
      </el-table-column>
      <el-table-column
          align="center"
          prop="area"
          label="城市">
      </el-table-column>
      <el-table-column
          align="center"
          label="焦炭库存">
        <el-table-column
            align="center"
            prop="coke_num"
            label="库存量">
        </el-table-column>
        <el-table-column
            align="center"
            prop="coke_usedays"
            label="可用天数">
        </el-table-column>
      </el-table-column>
      <el-table-column
          align="center"
          prop="weStockNumber"
          label="我方焦炭库存">
      </el-table-column>
      <el-table-column
          align="center"
          prop="otherStockNumber"
          label="竞争对手焦炭库存">
      </el-table-column>
      <el-table-column
          align="center"
          label="铁矿库存(万吨)">
        <el-table-column
            align="center"
            prop="iron_num"
            label="库存量">
        </el-table-column>
        <el-table-column
            align="center"
            prop="iron_usedays"
            label="可用天数">
        </el-table-column>
        <el-table-column
            align="center"
            prop="iron_num_used"
            label="月用量">
        </el-table-column>
      </el-table-column>
      <el-table-column
          align="center"
          label="钢材库存(万吨)">
        <el-table-column
            align="center"
            prop="pro_num"
            label="库存量">
        </el-table-column>
        <el-table-column
            align="center"
            prop="pro_usedays"
            label="可用天数">
        </el-table-column>
        <el-table-column
            align="center"
            prop="pro_num_used"
            label="月产量">
        </el-table-column>
      </el-table-column>
      <el-table-column
          align="center"
          label="开工率">
        <el-table-column
            align="center"
            prop="work_ratio_high"
            label="高炉">
        </el-table-column>
        <el-table-column
            align="center"
            prop="work_ratio_rotate"
            label="转炉">
        </el-table-column>
        <el-table-column
            align="center"
            prop="work_ratio_fire"
            label="烧结">
        </el-table-column>
        <el-table-column
            align="center"
            prop="work_ratio_steel_strip"
            label="带钢">
        </el-table-column>
        <el-table-column
            align="center"
            prop="work_ratio_steel_screw"
            label="螺纹钢">
        </el-table-column>
        <el-table-column
            align="center"
            prop="work_ratio_steel_wire"
            label="线材">
        </el-table-column>
        <el-table-column
            align="center"
            prop="work_ratio_steel_wire"
            label="中厚板">
        </el-table-column>
        <el-table-column
            align="center"
            prop="work_ratio_steel_wire"
            label="其他">
        </el-table-column>
      </el-table-column>
      <el-table-column
          align="center"
          label="吨产品盈利">
        <el-table-column
            align="center"
            prop="ton_profit_steel_strip"
            label="带钢">
        </el-table-column>
        <el-table-column
            align="center"
            prop="ton_profit_steel_screw"
            label="螺纹钢">
        </el-table-column>
        <el-table-column
            align="center"
            prop="ton_profit_steel_wire"
            label="线材">
        </el-table-column>
        <el-table-column
            align="center"
            prop="ton_profit_steel_mid"
            label="中厚板">
        </el-table-column>
        <el-table-column
            align="center"
            prop="ton_profit_steel_else"
            label="其他">
        </el-table-column>
      </el-table-column>
      <el-table-column
          align="center"
          prop="price_change"
          label="焦炭价格走势判断">
        <template slot-scope="scope">
          <span>{{scope.row['price_change'] === '1'? '涨':'跌'}}</span>
        </template>
      </el-table-column>
      <el-table-column
          align="center"
          prop="remarks"
          width="500px"
          label="情况说明">
      </el-table-column>
      <el-table-column
          align="center"
          prop="create_by"
          label="业务员">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import DetailTitle from '@/components/common/detatilTitle'
import {examineDetail, examineDetailEcharts} from '@/api/steel'

export default {
  name: "priceIndex",
  components: {
    DetailTitle
  },
  data() {
    return {
      endTime: '',
      tableData: [],
      tabHead: [],
      name: '',
    }
  },
  created() {
    this.endTime = this.$route.query.id;
  },
  methods: {
    /**
     * 获取详情
     */
    getDetail() {
      examineDetail({collection_time: this.endTime}).then(res => {
        this.tableData = res.data;
        this.getMapData()
      })
    },
    /**
     * 获取地图信息
     */
    getMapData() {
      let option = {
        title: {
          // text: ""
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          x: 'center',      //可设定图例在左、右、居中
          y: 'bottom',
          data: ['焦炭库存'],
          textStyle: {//图例文字的样式
            color: '#EE6666',
          },
          color: '#EE6666'
        },
        xAxis: {
          data: ['1月', '2月', '3月', '4月', '5月', '6月']
        },
        yAxis: {},
        series: [
          {
            name: "焦炭库存",
            type: "line",
            data: [5, 20, 36, 10, 10, 20],
            lineStyle: {
              color: '#EE6666' //改变折线颜色
            },
            itemStyle: {
              normal: {
                color: '#EE6666',
              }
            },
          },
        ],
        grid: {
          x: 50,
          y: 50,
          x2: 10,
          y2: 50
        },
      }
      let option1 = {
        title: {
          // text: ""
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          x: 'center',      //可设定图例在左、右、居中
          y: 'bottom',
          data: ['使用天数'],
          textStyle: {//图例文字的样式
            color: '#5470C6',
          },
          color: '#5470C6'
        },
        xAxis: {
          data: ['1月', '2月', '3月', '4月', '5月', '6月']
        },
        yAxis: {},
        series: [
          {
            name: "使用天数",
            type: "line",
            data: [5, 20, 36, 10, 10, 20],
            lineStyle: {
              color: '#5470C6' //改变折线颜色
            },
            itemStyle: {
              normal: {
                color: '#5470C6',
              }
            },
          },
        ],
        grid: {
          x: 50,
          y: 50,
          x2: 10,
          y2: 50
        },
      }
      let option2 = {
        title: {
          // text: ""
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          x: 'center',      //可设定图例在左、右、居中
          y: 'bottom',
          data: ['产品库存'],
          textStyle: {//图例文字的样式
            color: '#469F5A',
          },
          color: '#469F5A'
        },
        xAxis: {
          data: ['1月', '2月', '3月', '4月', '5月', '6月']
        },
        yAxis: {},
        series: [
          {
            name: "产品库存",
            type: "line",
            data: [5, 20, 36, 10, 10, 20],
            lineStyle: {
              color: '#469F5A' //改变折线颜色
            },
            itemStyle: {
              normal: {
                color: '#469F5A',
              }
            },
          },
        ],
        grid: {
          x: 50,
          y: 50,
          x2: 10,
          y2: 50
        },
      }
      let option3 = {
        title: {
          // text: ""
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          x: 'center',      //可设定图例在左、右、居中
          y: 'bottom',
          data: ['开工率'],
          textStyle: {//图例文字的样式
            color: '#73C0DE',
          },
        },
        xAxis: {
          data: ['1月', '2月', '3月', '4月', '5月', '6月']
        },
        yAxis: {},
        series: [
          {
            name: "开工率",
            type: "line",
            data: [5, 20, 36, 10, 10, 20],
            lineStyle: {
              color: '#73C0DE' //改变折线颜色
            },
            itemStyle: {
              normal: {
                color: '#73C0DE',
              }
            },
          },
        ],
        grid: {
          x: 50,
          y: 50,
          x2: 10,
          y2: 50
        },
      }
      examineDetailEcharts({collection_time: this.endTime}).then(res => {
        option['xAxis']['data'] = res.data['timeList']
        option1['xAxis']['data'] = res.data['timeList']
        option2['xAxis']['data'] = res.data['timeList']
        option3['xAxis']['data'] = res.data['timeList']

        option['series'][0]['data'] = res.data['data1']
        this.drawChart(option);
        option1['series'][0]['data'] = res.data['data2']
        this.drawChart1(option1);
        option2['series'][0]['data'] = res.data['data3']
        this.drawChart2(option2);
        option3['series'][0]['data'] = res.data['data4']
        this.drawChart3(option3);
      })
    },
    back(url) {
      this.$router.push({path: url});
    },
    /**
     * 加载地图
     */
    drawChart(option) {
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      myChart.setOption(option);
    },
    drawChart1(option) {
      let myChart = this.$echarts.init(document.getElementById("myChart1"));
      myChart.setOption(option);
    },
    drawChart2(option) {
      let myChart = this.$echarts.init(document.getElementById("myChart2"));
      myChart.setOption(option);
    },
    drawChart3(option) {
      let myChart = this.$echarts.init(document.getElementById("myChart3"));
      myChart.setOption(option);
    },
  },
  mounted() {
    this.getDetail();
  }
}
</script>

<style scoped lang="less">
.hzc-price-index {
  width: 1200px;
  margin: 0 auto;

  .tabs {
    margin: 15px 0;

    div {
      display: inline-block;
      margin-right: 16px;
      padding: 0 10px;
      height: 36px;
      background: #F2F2F2;
      border-radius: 4px;
      border: 1px solid #CCCCCC;
      text-align: center;
      line-height: 36px;
      cursor: pointer;
    }

    div:hover {
      background-color: #D3131A;
      color: #fff;
    }
  }

  .slot-span {
    display: inline-block;
    text-align: center;
    line-height: 25px;
    width: 74px;
    height: 25px;
    background: #F2F2F2;
    border-radius: 4px;
    border: 1px solid #CCCCCC;
    cursor: pointer;
  }

  .slot-span:hover {
    background-color: #D3131A;
    border: 1px solid #D3131A;
    color: #fff;
  }

  .slot-hover {
    background-color: #D3131A;
    border: 1px solid #D3131A;
    color: #fff;
  }

  .hzc-echarts {
    //background: #FFFFFF;
    //margin-top: 20px;
  }

  .echarts {
    position: relative;
    display: inline-block;
    margin-top: 24px;
    //width: 00px;
    height: 351px;

    .title {
      position: absolute;

      span {
        display: inline-block;
        width: 4px;
        height: 16px;
        background: #D3131A;
        vertical-align: middle;
      }

      p {
        display: inline-block;
        vertical-align: middle;
        font-size: 16px;
        font-weight: 500;
        color: #222;
        margin-left: 10px;
      }
    }
  }
}

.hover {
  background-color: #D3131A !important;
  border: 1px solid #D3131A !important;
  color: #fff;
}

.back {
  span {
    cursor: pointer;
  }
}

.red {
  color: #EA6535;
}

.green {
  color: #079F93;
}

.gray {
  color: #999999;
}
</style>
